/* eslint-disable react/prop-types */
import { products } from '../Data/products';
import { productsHealthcare , productsCommercial} from '../Data/products';
import classes from './Serv.module.scss';
import {Link} from 'react-router-dom' ;
import {linkToProduct} from '../Data/ProductsDetails' ;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {faStethoscope ,faGears ,faBriefcase} from '@fortawesome/free-solid-svg-icons'
import {faStethoscope  ,faBriefcase} from '@fortawesome/free-solid-svg-icons'
import { BsStars } from "react-icons/bs";




const Card = ({title , overview , secImg,to})=>{
    return (
        <div className={classes["room__card"]}>
            <div className={classes["room__card__image"]}>
                <img src={secImg} alt="product" loading="lazy"/>
            </div>
            <div className={classes["room__card__details"]}>
                <h4>{title}</h4>
                <p>
                    {overview}
                </p>
                <button className={classes["product___btn"]} >
                    <Link to={to}>Learn More</Link>
                </button>
            </div>
        </div>
    )
}

function Serv({Healthcare=false , Commercial=false}) {
    let data;
    let ico;
    Healthcare? data = productsHealthcare :Commercial? data= productsCommercial : data = products
    Healthcare? ico = <FontAwesomeIcon icon={faStethoscope} /> :Commercial? ico= <FontAwesomeIcon icon={faBriefcase} />  : ico = <BsStars />

    return (
        <section className={`${classes["room__container"]} ${classes["section__container"]}`}>
            <p className={classes["section__subheader"]}>{Commercial?'A Smart Products Portfolio' : 'Our Solutions'}</p>
            <h2 className={classes["section__header"]}>{ico} | {
                Commercial?'Complete set of financial management solutions for a total management of the organization'
                :'Complete set of software solutions for ultimate management of the healthcare organization'
            }</h2>
            <div className={classes["room__grid"]}>
                {/* {<Card/>} */}
                {data.map((ele,i)=>{
                    let link = linkToProduct(ele.title_2?ele.title_2:ele.title);
                    ele.to = link
                    return((<Card  key={i} to={ele.to} title={ele.title} secImg={ele.img} overview={ele.description}/>))
                })}
            </div>
        </section>
    )
}

export default Serv